(function () {
  'use strict';

  const stickyBar = document.getElementById('eb-sticky-atc');
  const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
  const mainForm = productInfo?.querySelector('product-form form');
  const mainAtcButton = mainForm?.querySelector('button[name="add"]');
  const stickyBtn = document.getElementById('eb-sticky-atc-btn');
  if (!stickyBar || !mainAtcButton || !stickyBtn) return;

  const stickySelect = document.getElementById('eb-sticky-variant');
  let navigating = false;

  function sync() {
    const id = mainForm.querySelector('input[name="id"]')?.value;
    if (stickySelect && !navigating) stickySelect.value = id || '';
    const unavailable = stickySelect && stickySelect.selectedOptions[0]?.dataset.available !== 'true';
    stickyBtn.disabled = navigating || mainAtcButton.disabled || mainAtcButton.getAttribute('aria-disabled') === 'true' || !!unavailable || !id;
    stickyBtn.textContent = mainAtcButton.querySelector('span')?.textContent.trim() || mainAtcButton.textContent.trim();
    const price = productInfo.querySelector('[id^="price-"]');
    const stickyPrice = document.getElementById('eb-sticky-price');
    if (price && stickyPrice) stickyPrice.innerHTML = price.innerHTML;
  }

  new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
  }, { threshold: 0 }).observe(mainForm);

  new MutationObserver(sync).observe(mainAtcButton, {
    attributes: true, childList: true, subtree: true,
    attributeFilter: ['disabled', 'aria-disabled']
  });

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (data.sectionId !== productInfo.dataset.section) return;
    const option = stickySelect && Array.from(stickySelect.options).find((item) => item.value === String(data.variant.id));
    if (option) option.dataset.available = String(data.variant.available);
    sync();
    const image = stickyBar.querySelector('img');
    if (image && data.variant.featured_image?.src) image.src = data.variant.featured_image.src;
  });

  stickySelect?.addEventListener('change', () => {
    navigating = true;
    stickyBtn.disabled = true;
    mainAtcButton.disabled = true;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', stickySelect.value);
    url.searchParams.delete('option_values');
    window.location.assign(url.toString());
  });

  stickyBtn.addEventListener('click', () => {
    sync();
    if (!stickyBtn.disabled) mainAtcButton.click();
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      window.location.reload();
    } else {
      window.setTimeout(sync, 0);
    }
  });

  window.addEventListener('popstate', () => {
    const variantId = new URL(window.location.href).searchParams.get('variant');
    if (variantId && variantId !== mainForm.querySelector('input[name="id"]')?.value) window.location.reload();
  });

  sync();
  stickyBar.hidden = false;
})();
